// Local translations
export const T = {
  en_GB: {
    selectView: "Select View",
    reviewClients: "Review Clients",
    results: "Results",
    selectClientView: "Select Client View",
    selectClientViewDesc:
      "Choose a view to run PEP/Sanction batch lookup on all clients in that view.",
    selectViewPlaceholder: "Select a view...",
    standard: "(Standard)",
    loadClients: "Load Clients",
    total: "Total",
    valid: "Valid",
    invalid: "Invalid",
    reviewClientsDesc:
      "Review the clients before running the batch lookup. Clients with missing required fields will be skipped.",
    noClientsInView: "No clients in this view.",
    status: "Status",
    name: "Name",
    type: "Type",
    ssnOrgNumber: "SSN / Org Number",
    country: "Country",
    issues: "Issues",
    edit: "Edit",
    back: "Back",
    runBatchLookup: "Run Batch Lookup",
    clients: "clients",
    batchLookupResults: "Batch Lookup Results",
    test: "Test",
    searched: "Searched",
    hits: "Hits",
    noHits: "No Hits",
    pep: "PEP",
    sanctioned: "Sanctioned",
    yes: "Yes",
    no: "No",
    currentStatus: "Current status",
    updatedStatus: "Updated status",
    goToReview: "Review clients",
    stNotChecked: "Never checked",
    stFailed: "Check failed",
    stClear: "No hits",
    stIncomplete: "PEP not assessed",
    pepNotAssessed: "Not assessed",
    pepVia: "PEP via",
    stNeedsReview: "Needs review",
    stAccepted: "Accepted",
    stBlocked: "Blocked",
    stNotAMatch: "Not a match",
    foundClientsWithMatches: (count: string) =>
      `Found ${count} client(s) with PEP/Sanction matches.`,
    noMatchesFound: "No PEP/Sanction matches found for any clients.",
    startOver: "Start Over",
    failedToLoadClients: "Failed to load clients",
    noValidClients: "No valid clients to search",
    failedToRunBatchLookup: "Failed to run batch lookup",
    trapetsDisabledTitle: "Trapets is disabled",
    trapetsDisabled:
      "PEP/Sanction screening is disabled for your organization. Enable Trapets in settings to run batch lookups.",
  },
  nb_NO: {
    selectView: "Velg visning",
    reviewClients: "Gjennomgå kunder",
    results: "Resultater",
    selectClientView: "Velg kundevisning",
    selectClientViewDesc:
      "Velg en visning for å kjøre PEP/sanksjonssøk på alle kunder i den visningen.",
    selectViewPlaceholder: "Velg en visning...",
    standard: "(Standard)",
    loadClients: "Last inn kunder",
    total: "Totalt",
    valid: "Gyldig",
    invalid: "Ugyldig",
    reviewClientsDesc:
      "Gjennomgå kundene før du kjører batchoppslaget. Kunder med manglende obligatoriske felt hoppes over.",
    noClientsInView: "Ingen kunder i denne visningen.",
    status: "Status",
    name: "Navn",
    type: "Type",
    ssnOrgNumber: "Fødselsnr. / Org.nr.",
    country: "Land",
    issues: "Problemer",
    edit: "Rediger",
    back: "Tilbake",
    runBatchLookup: "Kjør batchoppslag",
    clients: "kunder",
    batchLookupResults: "Resultat av batchoppslag",
    test: "Test",
    searched: "Søkt",
    hits: "Treff",
    noHits: "Ingen treff",
    pep: "PEP",
    sanctioned: "Sanksjonert",
    yes: "Ja",
    no: "Nei",
    currentStatus: "Nåværende status",
    updatedStatus: "Oppdatert status",
    goToReview: "Gjennomgå kunder",
    stNotChecked: "Aldri sjekket",
    stFailed: "Sjekk mislyktes",
    stClear: "Ingen treff",
    stIncomplete: "PEP ikke vurdert",
    pepNotAssessed: "Ikke vurdert",
    pepVia: "PEP via",
    stNeedsReview: "Trenger gjennomgang",
    stAccepted: "Godkjent",
    stBlocked: "Blokkert",
    stNotAMatch: "Ikke treff",
    foundClientsWithMatches: (count: string) => `Fant ${count} kunde(r) med PEP/sanksjons-treff.`,
    noMatchesFound: "Ingen PEP/sanksjons-treff funnet for noen kunder.",
    startOver: "Start på nytt",
    failedToLoadClients: "Kunne ikke laste inn kunder",
    noValidClients: "Ingen gyldige kunder å søke",
    failedToRunBatchLookup: "Kunne ikke kjøre batchoppslag",
    trapetsDisabledTitle: "Trapets er deaktivert",
    trapetsDisabled:
      "PEP/sanksjonssøk er deaktivert for organisasjonen din. Aktiver Trapets i innstillingene for å kjøre batchoppslag.",
  },
} as const;
